import { render, staticRenderFns } from "./OriginatorRule.vue?vue&type=template&id=054583f6&"
import script from "./OriginatorRule.vue?vue&type=script&lang=ts&"
export * from "./OriginatorRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports